import { useCallback, useState } from 'react';

const DISCARD_MESSAGE =
  'You have unsaved changes. Discard them and close the drawer?';

export const useDirtyCloseConfirm = (onClose: () => void) => {
  const [isDirty, setIsDirty] = useState(false);

  const attemptClose = useCallback(() => {
    if (!isDirty) {
      onClose();
      return;
    }
    const confirmed = window.confirm(DISCARD_MESSAGE);
    if (confirmed) {
      onClose();
    }
  }, [isDirty, onClose]);

  return { onDirtyChange: setIsDirty, attemptClose };
};
